import React, { useEffect, useState } from 'react';
import UserNamesAPI from '../api/UserNamesAPI';
import PlayerNameCombobox from './PlayerNameCombobox';

// The handle box on the signed-out home band (Pages/Index.cshtml), with the Player filter's saved-names
// dropdown. The band is a GET form to /try: picking a name submits it, and Enter with nothing
// highlighted submits as usual.
export default function FrontBandHandle({
  id,
  name,
  placeholder,
  initial,
  authenticated,
}: {
  id: string;
  name: string;
  placeholder: string;
  initial: string;
  authenticated: boolean;
}): React.ReactNode {
  const [value, setValue] = useState(initial);
  const [names, setNames] = useState<string[]>([]);

  useEffect(() => {
    if (!authenticated) {
      return;
    }
    UserNamesAPI.getSearchNames()
      .then(setNames)
      .catch(() => setNames([]));
  }, [authenticated]);

  return (
    <PlayerNameCombobox
      value={value}
      onChange={setValue}
      onCommit={() => undefined}
      onSelect={(picked) => {
        setValue(picked);
        // Let React flush the value into the input before the form reads it.
        window.setTimeout(() => {
          const input = document.getElementById(id) as HTMLInputElement | null;
          input?.form?.requestSubmit();
        }, 0);
      }}
      onRemove={
        authenticated
          ? (picked) => {
              setNames((list) => list.filter((n) => n !== picked));
              UserNamesAPI.removeSearchName(picked).catch(() => undefined);
            }
          : undefined
      }
      names={names}
      placeholder={placeholder}
      // Not `required`: an empty submit still reaches /try (see Pages/Index.cshtml).
      inputProps={{ id, name, type: 'text' }}
    />
  );
}
